import { useState, useEffect } from 'react';
import Icon from '../../../components/AppIcon';
import type { APIStatus } from '../types';

interface APIStatusPanelProps {
  status: APIStatus;
}

const APIStatusPanel = ({ status }: APIStatusPanelProps) => {
  const [currentTime, setCurrentTime] = useState(new Date());

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentTime(new Date());
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  const getTimeSinceSync = () => {
    const diff = Math.floor((currentTime.getTime() - status.lastSync.getTime()) / 1000);
    if (diff < 60) return `${diff}s atrás`;
    if (diff < 3600) return `${Math.floor(diff / 60)}m atrás`;
    return `${Math.floor(diff / 3600)}h atrás`;
  };

  return (
    <div className="bg-card rounded-lg border border-border p-6">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-lg font-semibold text-foreground">
          Status da API
        </h3>
        <div className="flex items-center gap-2">
          <div 
            className={`w-2 h-2 rounded-full ${
              status.isConnected ? 'bg-success' : 'bg-error'
            } animate-pulse`}
          />
          <span className={`text-sm font-medium ${
            status.isConnected ? 'text-success' : 'text-error'
          }`}>
            {status.isConnected ? 'Conectado' : 'Desconectado'}
          </span>
        </div>
      </div>

      <div className="space-y-4">
        <div className="flex items-center justify-between py-3 border-b border-border">
          <div className="flex items-center gap-3">
            <Icon name="Clock" size={18} color="var(--color-muted-foreground)" />
            <span className="text-sm text-muted-foreground">Última Sincronização</span>
          </div>
          <span className="text-sm font-medium text-foreground">
            {getTimeSinceSync()}
          </span>
        </div>

        <div className="flex items-center justify-between py-3 border-b border-border">
          <div className="flex items-center gap-3">
            <Icon name="Zap" size={18} color="var(--color-muted-foreground)" />
            <span className="text-sm text-muted-foreground">Tempo de Resposta</span>
          </div>
          <span className="text-sm font-medium text-foreground font-mono">
            {status.responseTime}ms
          </span>
        </div>

        <div className="flex items-center justify-between py-3">
          <div className="flex items-center gap-3">
            <Icon name="AlertCircle" size={18} color="var(--color-muted-foreground)" />
            <span className="text-sm text-muted-foreground">Erros (24h)</span>
          </div>
          <span className={`text-sm font-medium font-mono ${
            status.errorCount > 0 ? 'text-error' : 'text-success'
          }`}>
            {status.errorCount}
          </span>
        </div>
      </div>

      <div className="mt-4 p-3 bg-muted rounded-md">
        <div className="flex items-start gap-2">
          <Icon name="Info" size={16} color="var(--color-accent)" className="mt-0.5 flex-shrink-0" />
          <p className="text-xs text-muted-foreground leading-relaxed">
            Integração com Gestor Tributário 3.0 API. Token renovado automaticamente a cada 4 horas.
          </p>
        </div>
      </div>
    </div>
  );
};

export default APIStatusPanel;